import { useEffect } from "react";
import { Link } from "react-router-dom";
import { productUrl } from "../../utils/productUrl";
import { AiOutlineHeart } from "react-icons/ai";
import { useSelector } from "react-redux";
import Nav from "../../components/home/Nav";
import AccountList from "../../components/home/AccountList";
import Spinner from "../../components/Spinner";
import {
  useGetWishlistQuery,
  useRemoveWishlistMutation,
  useSyncWishlistMutation,
} from "../../store/services/authService";
import {
  clearLocalWishlist,
  localWishlistProductIds,
  readLocalWishlist,
} from "../../utils/wishlistStorage";
import { toman } from "../../utils/persian";

const imagePath = (item) => {
  const product = item?.product || item;
  const image = product?.main_image || product?.image || product?.gallery?.[0]?.url || product?.gallery?.[0]?.image;

  if (!image) return "";
  if (String(image).startsWith("http")) return image;

  return `/storage/${image}`;
};

const productId = (item) => item?.product_id || item?.product?.id || item?.id;

const productName = (item) => item?.product?.name || item?.name || item?.title || "محصول";

const productPrice = (item) => {
  const product = item?.product || item;
  return product?.sale_price || product?.price || 0;
};

const UserWishlist = () => {
  const { userToken } = useSelector((state) => state.authReducer);

  const { data, isLoading, isFetching } = useGetWishlistQuery(undefined, {
    skip: !userToken,
  });

  const [removeWishlist, removeResponse] = useRemoveWishlistMutation();
  const [syncWishlist] = useSyncWishlistMutation();

  useEffect(() => {
    if (!userToken) return;

    const ids = localWishlistProductIds();

    if (!ids.length) return;

    syncWishlist(ids)
      .unwrap()
      .then(() => clearLocalWishlist())
      .catch(() => {});
  }, [userToken, syncWishlist]);

  const localItems = readLocalWishlist();
  const items = userToken ? data?.items || [] : localItems;

  const removeItem = async (item) => {
    const id = productId(item);

    if (!id) return;

    if (userToken) {
      await removeWishlist(id);
      return;
    }

    const nextItems = readLocalWishlist().filter((row) => String(productId(row)) !== String(id));
    localStorage.setItem("jooti_wishlist", JSON.stringify(nextItems));
    localStorage.setItem("wishlist", JSON.stringify(nextItems));
    window.dispatchEvent(new CustomEvent("jooti:wishlist-updated"));
  };

  return (
    <>
      <Nav />

      <main className="account-page">
        <div className="my-container">
          <div className="account-shell">
            <AccountList />

            <section className="account-content">
              <div className="account-hero account-hero-compact">
                <div>
                  <span className="account-kicker">علاقه‌مندی‌ها</span>
                  <h1>لیست علاقه‌مندی‌ها</h1>
                  <p>محصولاتی که ذخیره کرده‌اید اینجا نمایش داده می‌شوند.</p>
                </div>
              </div>

              <section className="account-card">
                {isLoading || isFetching ? (
                  <Spinner />
                ) : items.length ? (
                  <div className="account-wishlist-grid">
                    {items.map((item) => (
                      <article className="account-wishlist-card" key={productId(item)}>
                        <Link to={productUrl(item)}>
                          <div>
                            {imagePath(item) ? <img src={imagePath(item)} alt={productName(item)} /> : null}
                          </div>
                          <strong>{productName(item)}</strong>
                          <span>{toman(productPrice(item))}</span>
                        </Link>

                        <button
                          type="button"
                          onClick={() => removeItem(item)}
                          disabled={removeResponse.isLoading}
                        >
                          حذف از علاقه‌مندی‌ها
                        </button>
                      </article>
                    ))}
                  </div>
                ) : (
                  <div className="account-empty-state">
                    <AiOutlineHeart size={42} />
                    <strong>لیست علاقه‌مندی‌ها خالی است</strong>
                    <p>با زدن آیکون قلب در صفحه محصول، آن را به این لیست اضافه کنید.</p>
                    <Link to="/products">دیدن محصولات</Link>
                  </div>
                )}
              </section>
            </section>
          </div>
        </div>
      </main>
    </>
  );
};

export default UserWishlist;
